/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actiontypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const handleErrorMessagesUpdateGeneralParam = (data) => ({
  type: actionTypes.HANDLE_ERROR_MESSAGE_UPG,
  errorMessagesInRedux: data,
});
export const setUpdateParamGeneralScreen = (data) => {
  return {
    type: actionTypes.UPDATE_PARAM_GENERAL_SCREEN_TAB_DATA,
    updateGeneralParamObj: data,
  };
};

export const dispatchUpdateGeneralParamResultDetails = (data) => ({
  type: actionTypes.GET_GENERAL_SYSTEM_PARAMETER_UPG,
  generalSystemParameter: data,
});
export const getGeneralSystemParameterDetails = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_GENERAL_SYSTEM_PARAMETER, values)
    .then((response) => {
      if (response?.data?.data?.paramGeneralVO) {
        dispatch(
          dispatchUpdateGeneralParamResultDetails(
            response?.data?.data?.paramGeneralVO?.[0]
          )
        );
      }
    })
    .catch(() => {
      dispatch(dispatchUpdateGeneralParamResultDetails([]));
    });
};
export const dispatchSaveOrUpdate = (values) => {
  return {
    saveOrUpdateMessage: values,
    type: actionTypes.SAVE_OR_UPDATE_UPG,
  };
};
// eslint-disable-next-line consistent-return
export const postSaveOrUpdate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_SYSTEM, value)
    .then((response) => {
      return dispatch(dispatchSaveOrUpdate(response.data));
    })
    .catch(() => {
      dispatch(dispatchSaveOrUpdate('failed'));
    });
};
export const clearReduxUpdateGeneralParamScreen = () => (dispatch) => {
  dispatch(dispatchUpdateGeneralParamResultDetails([]));
  dispatch(setUpdateParamGeneralScreen({}));
  dispatch(handleErrorMessagesUpdateGeneralParam([]));
  dispatch(dispatchSaveOrUpdate(''));
};
